var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M568 496H480V56C480 25.125 454.875 0 424 0H152C121.125 0 96 25.125 96 56V496H8C3.594 496 0 499.594 0 504S3.594 512 8 512H568C572.406 512 576 508.406 576 504S572.406 496 568 496ZM464 496H112V56C112 33.938 129.938 16 152 16H424C446.062 16 464 33.938 464 56V496ZM384 216C361.938 216 344 233.938 344 256S361.938 296 384 296S424 278.062 424 256S406.062 216 384 216ZM384 280C370.781 280 360 269.219 360 256S370.781 232 384 232S408 242.781 408 256S397.219 280 384 280Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorClosed);
export default __webpack_public_path__ + "static/media/door-closed.1938a8d61ded4fda0221e40ce1520f92.svg";
export { ForwardRef as ReactComponent };